/////tsnocheck
import createClient from '../create-client';
import { Stripe } from 'stripe';

export class CloudApiClient {
  private client: ReturnType<typeof createClient>;

  constructor(getToken?: () => Promise<string | undefined>) {
    this.client = createClient(``, getToken);
  }

  public async getCheckoutLink(isAnnual = false) {
    const res = await this.client.get<Stripe.Response<Stripe.Checkout.Session>>(
      `/createCheckout` + (isAnnual ? '?isAnnual=true' : '')
    );

    return res.url;
  }

  public registerGetToken(
    baseUrl: string,
    getToken?: () => Promise<string | undefined>
  ) {
    this.client = createClient(baseUrl, getToken);

    return this;
  }
}

export default new CloudApiClient();
